// Çalışan Analizi (/employee-analysis) ve FTE Yönetimi penceresi. Proje, rol
// ve tarife adları kayıtlı değerlerdir; Excel dosyası Türkçe kalır.
const employeeAnalysis = {
  page: {
    title: 'Çalışan Analizi',
    subtitle: 'Çalışan başına projeler, roller, visit sayıları ve giderler.',
  },
  actions: {
    excel: 'Tabloyu İndir',
    excelHint: 'Tüm atamaları ödeme ayrıntılarıyla Excel olarak indir',
  },
  stats: {
    workers: 'Toplam Çalışan',
    workersShort: 'Çalışan',
    projects: 'Aktif Proje',
    projectsShort: 'Proje',
    visits: 'Toplam Visit',
    visitsShort: 'Visit',
    expense: 'Toplam Gider',
    expenseShort: 'Gider',
    loading: 'yükleniyor…',
  },
  toolbar: {
    search: 'Genel arama (isim, proje, rol)…',
    searchShort: 'Ara…',
    sort: 'Sırala',
    sortBy: {
      name: 'Çalışan',
      projects: 'Proje sayısı',
      visits: 'Toplam visit',
      expense: 'Toplam gider',
    },
    asc: 'Artan sıra',
    desc: 'Azalan sıra',
  },
  columns: {
    employee: 'Çalışan',
    project: 'Projeler',
    role: 'Roller',
    visits: 'Toplam Visit',
    expense: 'Toplam Gider',
  },
  table: {
    listLabel: 'Çalışanlar',
    empty: 'Filtrelere uygun veri bulunamadı',
    rangeOf: '/ {{total}} çalışan',
    ofTotal: 'toplam {{total}} çalışan içinden',
    jump: 'Sayfaya git',
    projectCount: '{{count}} proje',
    cardLine: '{{projects}} proje · {{visits}} visit',
  },
  panel: {
    label: 'Seçili çalışan',
    heading: 'Çalışan analizi',
    summary: '{{projects}} proje · {{visits}} visit · {{expense}}',
    projectsOnly: '{{projects}} proje',
    fte: 'FTE Yönetimi',
    statistics: 'İstatistikler',
    assignments: 'Proje atamaları',
    rate: 'Tarife: {{type}} – {{value}}',
    assignmentTotals: '{{visits}} visit · {{expense}} gider',
    loadingDetails: 'Visit ve gider yükleniyor…',
    visits: 'Visitler',
    tariffs: 'Tarife ayrıntıları',
    noTariffs: 'Bu çalışan için tarife bilgisi bulunamadı.',
    tariffTotal: 'Tarife toplamı',
  },
  fte: {
    title: 'FTE Yönetimi',
    subtitle: '{{name}} · proje bazlı FTE atamaları',
    empty: 'Bu çalışan için proje ataması bulunamadı',
    current: 'Mevcut: {{type}} – {{value}}',
    choose: 'FTE seçimi',
    placeholder: 'Seçiniz',
    noTariffs: 'Bu proje için FTE tarifesi tanımlı değil.',
    projectsError: 'Proje bilgileri yüklenirken hata oluştu',
    tariffsError: 'Tarife bilgileri yüklenirken hata oluştu',
    saveError: 'FTE bilgileri kaydedilirken hata oluştu',
  },
  common: {
    cancel: 'İptal',
    save: 'Kaydet',
    saving: 'Kaydediliyor…',
    loading: 'Yükleniyor…',
  },
  toast: {
    loadError: 'Çalışan bilgileri yüklenirken hata oluştu!',
    bulkError: 'Visit, gider ve ödeme verileri yüklenirken bir hata oluştu.',
    noVisits: 'Bu çalışanın visit’i bulunamadı.',
    visitsError: 'Ziyaret bilgileri alınırken bir hata oluştu.',
    refreshing: 'Veriler güncelleniyor…',
    fteSaved: 'FTE bilgileri başarıyla güncellendi!',
    refreshError: 'Veriler güncellenirken hata oluştu',
    excelDone: 'Excel dosyası başarıyla indirildi',
    pageJumpInvalid: 'Lütfen 1 ile {{max}} arasında bir sayfa numarası girin.',
  },
};

export default employeeAnalysis;
